/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest
 */
export interface FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest
     */
    Key: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest(value: object): value is FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest {
    if (!('Key' in value) || value['Key'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestFromJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Key': json['Key'],
    };
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestToJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestToJSONTyped(value?: FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Key': value['Key'],
    };
}

